import React from 'react';
import moment from 'moment';
import { Permissions } from 'components/Permissions';
import { Comments } from 'views/shared/Comments';
import { DocLink, DocPages } from 'components/Help';
import { getActiveIcon } from 'library/helpers';
import ActionInput from './input';

const config = {
  // List Table
  list: {
    // Table Columns
    columns: [
      {
        title: 'Action ID',
        dataIndex: 'id',
        sorter: true,
        defaultSortOrder: 'ascend',
        width: '80px',
        render: (text, record) => record.id
      },
      {
        title: 'Action Type',
        dataIndex: 'action_type__name',
        key: 'action_type__name',
        sorter: true,
        defaultSortOrder: 'ascend',
        width: '180px',
        render: (text, record) => record.action_type.name
      },
      {
        title: 'Status',
        dataIndex: 'status__name',
        sorter: true,
        defaultSortOrder: 'ascend',
        width: '180px',
        render: (text, record) => record.status.name
      },
      {
        title: 'Priority',
        dataIndex: 'priority__name',
        sorter: true,
        defaultSortOrder: 'ascend',
        width: '180px',
        render: (text, record) => record.priority.name
      },
      {
        title: 'Follow Up Date',
        dataIndex: 'follow_up_date',
        sorter: true,
        defaultSortOrder: 'ascend',
        width: '180px',
        render: (text, record) => (record.follow_up_date ? moment(record.follow_up_date)
          .format('DD-MM-YYYY HH:mm') : 'NA')
      },
      {
        title: 'Requestor',
        dataIndex: 'requestor__last_name',
        sorter: true,
        width: '180px',
        render: (text, record) => `${record.requestor.last_name}, ${record.requestor.first_name}`
      },
      {
        title: 'Resolved',
        dataIndex: 'status__is_resolved',
        align: 'center',
        sorter: true,
        defaultSortOrder: 'ascend',
        filterMultiple: false,
        filters: [
          {
            text: 'Yes',
            value: true
          },
          {
            text: 'No',
            value: false
          }
        ],
        width: '120px',
        render: (text, record) => getActiveIcon(record.status.is_resolved)
      }
    ],
    // Deleting
    confirmMessage: item => (
      <div>
        <p>
          Are you sure you wish to delete the action type
          <b>{item.name}</b>
          ?
        </p>
        <p>
          This action cannot be undone.
        </p>
      </div>
    ),
    // Filtering
    sorter: {
      field: 'id',
      order: 'descend'
    },
    filters: {
      status__is_resolved: [false]
    },
    customFilters: {
      action_type__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['action_type__name'],
        searchValue: ''
      },
      requestor__last_name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['requestor__last_name'],
        searchValue: '',
        filterSettings: {
          title: null,
          reducerKey: 'userCollectionValues',
          placeholder: 'requestors',
          themeName: 'user',
          showClearButton: false,
          initCustomFilterValues: {
            item: {
              contains: true,
              searchFields: ['requestor__last_name'],
              searchValue: ''
            },
            ids: {
              contains: false,
              searchFields: ['requestor__id__in'],
              searchValue: []
            }
          }
        }
      },
      status__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['status__name'],
        searchValue: ''
      },
      priority__name: {
        filterDropdownVisible: false,
        filtered: false,
        contains: true,
        searchFields: ['priority__name'],
        searchValue: ''
      }
    },
    // General
    title: <DocLink page={DocPages.actions}>Actions</DocLink>
  },
  // Detail Screen
  detail: {
    // General
    emptyMessage: 'Please select an Action',
    title: 'Action',
    tabItems: [
      {
        key: 0,
        title: 'Details',
        component: props => (
          <ActionInput
            {...props}
            title="Action"
          />
        )
      },
      {
        key: 1,
        title: 'Comments',
        component: props => (
          <Permissions.Consumer>
            {({ permissions }) => (permissions.BasicAccess()
              .hasPermissions() || permissions.CanViewComments()
              .hasPermissions()) && ( // need basic or viewable permissions
              <Comments
                {...props}
                title="Comments"
                themeName="action"
                canAdmin={permissions.BasicAccess()
                  .hasPermissions()} // basic access can add comments
                permissions={permissions}
              />
            )}
          </Permissions.Consumer>
        )
      }
    ]
  }
};

export default config;
